/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpHead_viewer$ref: FragmentReference;
export type PdpHead_viewer = {|
  +isPdpUrlTranslationEnabled: ?boolean,
  +$refType: PdpHead_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpHead_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isPdpUrlTranslationEnabled",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "translatedPdpUrls",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"translatedPdpUrls\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ef125614954ce0c1dfcbe52ac1e72cf2';
module.exports = node;
